import {grid} from '@xh/hoist/cmp/grid';
import {filler, fragment, frame} from '@xh/hoist/cmp/layout';
import {hoistCmp, uses} from '@xh/hoist/core';
import {button} from '@xh/hoist/desktop/cmp/button';
import {textInput} from '@xh/hoist/desktop/cmp/input';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {Icon} from '@xh/hoist/icon';
import {dialog} from '@xh/hoist/kit/blueprint';
import './SecurityImportDialog.scss';
import {SecurityImportDialogModel} from './SecurityImportDialogModel';

export const securityImportDialog = hoistCmp.factory({
    className: 'security-import-dialog',
    model: uses(SecurityImportDialogModel),
    render({className, model}) {
        return dialog({
            className,
            isOpen: model.isOpen,
            title: 'Import Security',
            icon: Icon.cloudDownload({prefix: 'fas'}),
            onClose: () => model.close(),
            canEscapeKeyClose: false,
            canOutsideClickClose: false,
            item: fragment(
                panel({
                    tbar: tbar(),
                    item: frame(grid()),
                    bbar: bbar(),
                    mask: [model.loadTask, model.importTask]
                })
            )
        });
    }
});

const tbar = hoistCmp.factory<SecurityImportDialogModel>(({model}) =>
    toolbar(
        textInput({
            bind: 'searchString',
            flex: 1,
            placeholder: 'Enter a ticker / name / description',
            leftIcon: Icon.search(),
            autoFocus: true,
            commitOnChange: true,
            enableClear: true
        })
    )
);

const bbar = hoistCmp.factory<SecurityImportDialogModel>(({model}) =>
    toolbar(
        filler(),
        button({
            text: 'Close',
            onClick: () => model.close()
        })
    )
);
